import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "repeat-pickure" }

import { ref, computed } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  XrkTableRef,
  BaseImage,
  BaseButton
} from 'xrk-components';
import { getSimilarTaskDetail } from '../data-source/apis';
import { formatter } from '@/utils';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { useTaskAudit } from '../hooks/useTaskAudit';
import { PLATFORM_AUDIT_STATUS } from '../constants';

export default /*#__PURE__*/_defineComponent({
  __name: 'repeat-pickure',
  props: {
    projectId: {},
    taskId: {},
    similarTaskIdList: {}
  },
  setup(__props: any) {

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
const xrkTableRef = ref<XrkTableRef>();

const props = __props;

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: []
});

const onRefreshTabel = () => {
  xrkTableRef.value?.initCurrentList();
};

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      label: '提交时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '项目参与人',
      prop: 'userName'
    }),
    useTableColumn({
      label: '任务编码',
      prop: 'taskCode'
    }),
    useTableColumn({
      label: '重复图片',
      prop: 'imageList',
      showOverflowTooltip: false,
      render({ cellValue }) {
        return (
          <>
            {cellValue.map((item, index) => {
              return (
                <BaseImage
                  previewTeleported={true}
                  style="width: 100px;height: 100px;margin-right:5px"
                  src={item}
                  initial-index={index}
                  preview-src-list={cellValue}
                ></BaseImage>
              );
            })}
          </>
        );
      }
    }),
    useTableColumn({
      label: '服务商状态',
      prop: 'aspAuditStatus',
      formatter: ({ cellValue }) => PLATFORM_AUDIT_STATUS[cellValue].label
    }),
    useTableColumn({
      label: '平台状态',
      prop: 'platformAuditStatus',
      formatter: ({ cellValue }) => PLATFORM_AUDIT_STATUS[cellValue].label
    }),
    useTableColumn({
      label: '工业状态',
      prop: 'industryAuditStatus',
      formatter: ({ cellValue }) => PLATFORM_AUDIT_STATUS[cellValue].label
    }),
    useTableColumn({
      label: '操作',
      fixed: 'right',
      render: ({ row }) => {
        return (
          <>
            <div>
              <BaseButton
                disabled={row.buttonOnOff === 0 || row.buttonOnOff === 2}
                onClick={() => {
                  useTaskAudit({
                    auditStatus: 2,
                    projectId: props.projectId,
                    queryParams: {
                      sceneType: projectInfo.value.sceneType,
                      taskRecordId: [row.id]
                    },
                    auditOver() {
                      xrkTableRef.value.clearSelectionRows();
                      onRefreshTabel();
                    }
                  });
                }}
                type="text"
              >
                通过
              </BaseButton>
              <BaseButton
                disabled={row.buttonOnOff === 0}
                onClick={() => {
                  useTaskAudit({
                    auditStatus: 3,
                    projectId: props.projectId,
                    queryParams: {
                      sceneType: projectInfo.value.sceneType,
                      taskRecordId: [row.id]
                    },
                    auditOver() {
                      xrkTableRef.value.clearSelectionRows();
                      onRefreshTabel();
                    }
                  });
                }}
                type="text"
              >
                不通过
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ]
});

const getListAjax = async params => {
  const data = await getSimilarTaskDetail({
    ...params,
    taskId: props.taskId,
    projectId: props.projectId,
    similarTaskIdList: props.similarTaskIdList
  });
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})